export default __webpack_public_path__ + "static/servicesDecorator-e240b406c228dad895f3d1b4a729c860.png";